/* eslint-disable i18next/no-literal-string */
import { isBrowser } from 'utils/misc-utils';

export const isAnalyticsDebugMode = (): boolean =>
  process.env.NODE_ENV !== 'production' ||
  (isBrowser() && new URLSearchParams(window.location.search).has('debugAnalytics'));
